require('./style.less');

var Marionette = require('marionette'),
    Backbone = require('backbone'),
    PageNotRenderable = require('../../../page/unRenderable/unrenderablePg').pdf;

module.exports =  Marionette.CollectionView.extend({
    id: 'pdfModeUnrenderablePgs',
    childView: PageNotRenderable,
    childViewOptions: function() {
        return {
            vChannel: this.options.vChannel
        };
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/pdfMode/unrenderablePages/view.js
 ** module id = 477
 ** module chunks = 0
 **/